export default "b12c1f4a2429a687.png"